











import { defineComponent, ref } from '@vue/composition-api';
import OlbIcon from '../icon/icon.vue';

export default defineComponent({
	components: {
		OlbIcon,
	},
	setup(props, { emit }) {
		const isShown = ref(true);

		function close() {
			emit('close-event');
			isShown.value = false;
		}

		return { close, isShown };
	},
});
